import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "on",
  "use": "on-usage",
  "viewBox": "0 0 19.75 26.33",
  "content": "<symbol viewBox=\"0 0 19.75 26.33\" id=\"on\"><title>资源 14</title><g id=\"on_图层_2\" data-name=\"图层 2\"><g id=\"on_图层_1-2\" data-name=\"图层 1\"><path d=\"M14,20.08A7.79,7.79,0,0,0,9.8,5.7H9.58A7.79,7.79,0,0,0,5.64,20.08a.47.47,0,0,1,.22.39v1H4.36a.88.88,0,1,0,0,1.76H15.24a.88.88,0,1,0,0-1.76h-1.5v-1A.47.47,0,0,1,14,20.08Z\" /><path d=\"M3.17,7.66a.88.88,0,0,0,0-1.25L1.5,4.75A.88.88,0,0,0,.26,6L1.92,7.66a.88.88,0,0,0,.62.26A.87.87,0,0,0,3.17,7.66Z\" /><path d=\"M9.8,4.11a.88.88,0,0,0,.88-.88V.88a.88.88,0,0,0-1.76,0V3.23A.88.88,0,0,0,9.8,4.11Z\" /><path d=\"M13.88,24.57H5.72a.88.88,0,0,0,0,1.76h8.16a.88.88,0,1,0,0-1.76Z\" /><path d=\"M19.49,4.73a.88.88,0,0,0-1.25,0L16.58,6.39a.88.88,0,0,0,.62,1.5.87.87,0,0,0,.62-.26L19.49,6A.88.88,0,0,0,19.49,4.73Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/on.svg
// module id = MFTv
// module chunks = 264